<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 111 111"
  >

    <g data-name="Group 1829">
      <path
        data-name="Rectangle 376"
        :style="{fill: bgColor}"
        d="M0 0h111v111H0z"
      />
      <path
        d="M53.458 35.3a3.027 3.027 0 0 0-3.027 3.027V39.5l-4.48-4.48a8.385 8.385 0 0 0-11.9 0l-2.119 2.119-7.502-7.533a8.657 8.657 0 0 0-11.9 0l-4.48 4.48V17.135a3.027 3.027 0 0 1 3.027-3.027H35.3a3.027 3.027 0 1 0 0-6.054H11.081A9.081 9.081 0 0 0 2 17.135v36.323a9.081 9.081 0 0 0 9.081 9.081H47.4a9.081 9.081 0 0 0 9.081-9.081V38.323a3.027 3.027 0 0 0-3.023-3.023zM11.081 56.485a3.027 3.027 0 0 1-3.027-3.027V42.652l8.778-8.778a2.391 2.391 0 0 1 3.3 0l9.6 9.6 12.981 13.011zm39.35-3.027a3.027 3.027 0 0 1-.545 1.6L36.235 41.35l2.119-2.119a2.361 2.361 0 0 1 3.33 0l8.748 8.839zM52.458 3a9.081 9.081 0 0 0-7.87 4.54 3.024 3.024 0 1 0 5.237 3.027 3.031 3.031 0 1 1 2.633 4.54 3.027 3.027 0 1 0 0 6.054 9.081 9.081 0 1 0 0-18.161zm1.15 21.431a3.027 3.027 0 0 0-1.756-.242l-.545.182-.545.272-.454.394a3.064 3.064 0 1 0 3.3-.605z"
        transform="translate(23.23 23.23)"
        :style="{fill: color}"
      />
    </g>
  </svg>

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ImageBrokenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isDark: 'appConfig/isDark',
    }),
    bgColor() {
      return this.isDark ? '#161d31' : '#ffffff'
    },
    color() {
      return this.isDark ? '#404656' : '#efefef'
    },
  },
}
</script>
